
import Vue from "vue";
import Component from "vue-class-component";

import PersonalChat from "@/views/apps/message/PersonalChat.vue";
import BroadcastChat from "@/views/apps/message/BroadcastChat.vue";
import { Action, State } from "vuex-class";
import filters from "@/filters";
import { MessagingSubscriptionInfoModel } from "@/models/messaging.model";
import { messagingSubscriptionStatus, webinarSubscriptionStatus } from "@/constants/enum.constant";
import ModalMessagingSubscribe from "@/components/messaging/ModalMessagingSubscribe.vue";
import toast from "@/functions/toast.function";
import ModalMessagingTerms from "@/components/messaging/ModalMessagingTerms.vue";
import { AxiosResponse } from "axios";

@Component({
  components: {
    ModalMessagingTerms,
    ModalMessagingSubscribe,
    PersonalChat,
    BroadcastChat,
  },
})
export default class Message extends Vue {
  /* VUEX */

  /* ACTION */
  @Action("actionGetSubscriptionInfo", {namespace: "messaging"})
  private actionGetSubscriptionInfo: any;
  @Action("actionGetAccess", {namespace: "messaging"})
  private actionGetAccess: any;

  /* STATE */
  @State("school", {namespace: "academy"})
  private school: any;
  @State("messaging_subscription_info", {namespace: "messaging"})
  private messaging_subscription_info: MessagingSubscriptionInfoModel;

  /* INITIALIZATION */
  private tabs: any = null;
  private keyBroadcastChat: number = 0;
  private showModalTerms: boolean = false;
  private showModalPayment: boolean = false;
  private canAccess: boolean = false;

  private get canOpenSubscribe() {
    return (
      this.messaging_subscription_info.status !== messagingSubscriptionStatus.WAITING_APPROVAL &&
      this.messaging_subscription_info.status !== messagingSubscriptionStatus.PAID
    );
  }

  private get showSubscription() {
    return (
      this.messaging_subscription_info.status !== 0 &&
      this.messaging_subscription_info.status !== messagingSubscriptionStatus.PAID
    );
  }

  private get subscriptionTextInfo() {
    if (this.messaging_subscription_info.status === messagingSubscriptionStatus.UNPAID) return this.$i18n.t("subscription_info_inactive");
    else if (this.messaging_subscription_info.status === messagingSubscriptionStatus.WAITING_APPROVAL) return this.$i18n.t("subscription_info_waiting_approval");
    else if (this.messaging_subscription_info.status === messagingSubscriptionStatus.REJECTED) return `${this.$i18n.t("subscription_info_rejected")}<br/>Note: ${this.messaging_subscription_info.note}`;
    else if (this.messaging_subscription_info.status === messagingSubscriptionStatus.PAID) return `${this.$i18n.t("subscription_info_active")} <strong>${filters.date(this.messaging_subscription_info.end_date, null)}</strong>`;
  }

  private openModalPayment() {
    if (this.messaging_subscription_info.status === webinarSubscriptionStatus.UNPAID || this.messaging_subscription_info.status === webinarSubscriptionStatus.REJECTED) this.showModalTerms = true;
    else if (this.messaging_subscription_info.status === webinarSubscriptionStatus.WAITING_APPROVAL) toast.warning(this.$i18n.t("subscription_info_waiting_approval"));
    else toast.error("Whoops, something went wrong.");
  }

  private mounted() {
    console.log("school", this.school.id);
    if (this.school.id) {
      this.actionGetSubscriptionInfo({
        params: {
          school_id: this.school.id
        }
      });
      this.actionGetAccess({
        params: {school_id: this.school.id},
        success: (res: AxiosResponse) => {
          this.canAccess = res.data;
        },
      });
    }
  }

  /* METHODS */
  private openTerms() {
      this.showModalTerms = true;
  }

  private onRefresh() {
    this.keyBroadcastChat += 1;
  }
}
